import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import ExposedLocationVisitListEnhanced from "../ExposedLocationVisitList/ExposedLocationVisitListEnhanced"
import { entitiesPropTypes } from "../../utils/propTypes"
import "./ExposedLocationVisitListModal.scss"

const ExposedLocationVisitListModal = (props) => {
  const [modal, setModal] = useState(false)
  useEffect(() => {
    props.locationId && props.startAt && props.endAt && setModal(true)
  }, [props])

  const closeButton = (
    <button
      className="close-button fa fa-times"
      type="button"
      title="button"
      onClick={() => setModal(!modal)}
    />
  )

  return (
    <Modal
      isOpen={modal}
      size={"lg"}
      centered={true}
      className={"exposed-location-visits"}
    >
      <ModalHeader close={closeButton} />
      <ModalBody>
        {props.locationId && props.startAt && props.endAt && (
          <ExposedLocationVisitListEnhanced {...props} />
        )}
      </ModalBody>
    </Modal>
  )
}

ExposedLocationVisitListModal.propTypes = {
  entities: entitiesPropTypes,
  name: PropTypes.string,
  unit: PropTypes.string,
  compliance: PropTypes.number,
  locationId: PropTypes.string,
  startAt: PropTypes.string,
  endAt: PropTypes.string,
}

export default ExposedLocationVisitListModal
